import { render, staticRenderFns } from "./ClientBlogs.vue?vue&type=template&id=a2225a38&scoped=true&"
import script from "./ClientBlogs.vue?vue&type=script&lang=js&"
export * from "./ClientBlogs.vue?vue&type=script&lang=js&"
import style0 from "./ClientBlogs.vue?vue&type=style&index=0&id=a2225a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2225a38",
  null
  
)

export default component.exports